'use client';
import { useState, useEffect } from 'react';
import ImageComparisonSlider from '@/components/ImageComparisonSlider';
import type { ComparisonImages } from '../data/comparison-images';

interface StunQualityProps {
  imagesData: ComparisonImages;
  title?: string;
  defaultTab?: string;
  translations?: {
    title: string;
    defaultTab: string;
  };
}

const StunQuality = ({
  imagesData,
  title = 'Stunning quality',
  defaultTab,
  translations,
}: StunQualityProps) => {
  const tabs = Object.keys(imagesData);
  const [activeTab, setActiveTab] = useState<string>('');

  // 使用translations如果存在
  const displayTitle = translations?.title || title;
  const translatedDefaultTab = translations?.defaultTab || defaultTab;

  // 确保组件挂载时就有有效的activeTab
  useEffect(() => {
    if (!activeTab && tabs.length > 0) {
      // 优先使用defaultTab（如果它存在于imagesData中）
      if (translatedDefaultTab && imagesData[translatedDefaultTab]) {
        setActiveTab(translatedDefaultTab);
      } else if (defaultTab && imagesData[defaultTab]) {
        setActiveTab(defaultTab);
      } else {
        // 否则使用第一个可用的tab
        setActiveTab(tabs[0]);
      }
    }
  }, [activeTab, defaultTab, translatedDefaultTab, imagesData, tabs]);

  return (
    <section className='section-container mt-0 items-start md:items-center lg:mt-20'>
      <h2 className='font-geist w-full text-center text-2xl font-semibold md:text-[44px]'>
        {displayTitle}
      </h2>
      <div className='tabs mt-7 grid grid-flow-col grid-rows-2 justify-start gap-1 md:mt-12 md:grid-rows-1 md:justify-center md:gap-4'>
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`h-fit w-fit rounded-full px-5 py-[6px] text-base font-medium text-gray-800 ${
              activeTab === tab ? 'active bg-gray-800 text-white' : ''
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>
      <div className='mt-12 w-full'>
        {activeTab &&
          imagesData[activeTab] &&
          imagesData[activeTab].length >= 2 && (
            <ImageComparisonSlider
              key={activeTab}
              beforeImage={imagesData[activeTab][1]}
              afterImage={imagesData[activeTab][0]}
              width={600}
              height={400}
            />
          )}
      </div>
    </section>
  );
};

export default StunQuality;
